
  import {Component, Vue} from "vue-property-decorator";
  import AppPageHeader from "@/components/AppPageHeader.vue";
  import FeedbackForm from "@/modules/Support/components/FeedbackForm.vue";

  @Component({
    components: {
      AppPageHeader,
      FeedbackForm,
    },
  })
  export default class PageSupport extends Vue {
    isLoading: boolean = true;
    publicPath = process.env.VUE_APP_PUBLIC_URL;

    async created() {
      await this.$store.dispatch('auth/init');
      await this.$store.dispatch('initialized');
      this.isLoading = false;
    }

  }
